"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscribedToChannel = exports.hasSubscriptionPriceInfo = exports.getPlayButtonType = exports.shouldShowChannelCover = exports.mainItemIsChannelCover = exports.shouldShowSubscribeButton = exports.getBuyButtonDisplayTypeForPaidVideo = exports.getBuyButtonDisplayType = exports.canAccessFullVersionOfVideo = exports.getBuyButtonDisplayTypeWhenInOverlay = exports.PLAY_BUTTON_TYPES = exports.PLAY_BUTTON_DISPLAY_TYPES = exports.BUY_BUTTON_DISPLAY_TYPES = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var main_item_type_values_1 = require("@wix/wix-vod-constants/dist/app-settings/main-item-type-values");
var dealInfoHelpers = tslib_1.__importStar(require("./deal-info-helpers"));
var pricing_1 = require("../ui-selectors/video/pricing");
var BUY_BUTTON_DISPLAY_TYPES;
(function (BUY_BUTTON_DISPLAY_TYPES) {
    BUY_BUTTON_DISPLAY_TYPES["BUY"] = "buy";
    BUY_BUTTON_DISPLAY_TYPES["RENT"] = "rent";
    BUY_BUTTON_DISPLAY_TYPES["BUY_FROM"] = "buyFrom";
    BUY_BUTTON_DISPLAY_TYPES["NONE"] = "none";
})(BUY_BUTTON_DISPLAY_TYPES = exports.BUY_BUTTON_DISPLAY_TYPES || (exports.BUY_BUTTON_DISPLAY_TYPES = {}));
var PLAY_BUTTON_DISPLAY_TYPES;
(function (PLAY_BUTTON_DISPLAY_TYPES) {
    PLAY_BUTTON_DISPLAY_TYPES["PLAY_VIDEO"] = "play-video";
    PLAY_BUTTON_DISPLAY_TYPES["WATCH_NOW"] = "watch-now";
    PLAY_BUTTON_DISPLAY_TYPES["WATCH_TRAILER"] = "watch-trailer";
    PLAY_BUTTON_DISPLAY_TYPES["WATCH_PREVIEW"] = "watch-preview";
    PLAY_BUTTON_DISPLAY_TYPES["NONE"] = "none";
})(PLAY_BUTTON_DISPLAY_TYPES = exports.PLAY_BUTTON_DISPLAY_TYPES || (exports.PLAY_BUTTON_DISPLAY_TYPES = {}));
var PLAY_BUTTON_TYPES;
(function (PLAY_BUTTON_TYPES) {
    PLAY_BUTTON_TYPES["PLAY"] = "play";
    PLAY_BUTTON_TYPES["TRAILER_OR_PREVIEW"] = "trailer_or_preview";
})(PLAY_BUTTON_TYPES = exports.PLAY_BUTTON_TYPES || (exports.PLAY_BUTTON_TYPES = {}));
// Todo: remove. Use widget/ui-selectors/video-access
function getBuyButtonDisplayTypeWhenInOverlay(_a) {
    var settings = _a.settings, videoItem = _a.videoItem, channelData = _a.channelData, showChannelCover = _a.showChannelCover;
    // case when user has not yet selected any video
    if (showChannelCover) {
        // only show buy button for featured video or when a video is ended. Otherwise no buy button
        if (mainItemIsChannelCover(settings)) {
            return BUY_BUTTON_DISPLAY_TYPES.NONE;
        }
    }
    return getBuyButtonDisplayType(channelData, videoItem);
}
exports.getBuyButtonDisplayTypeWhenInOverlay = getBuyButtonDisplayTypeWhenInOverlay;
function canAccessPaidVideo(channelData, videoItem) {
    if (isSubscribedToChannel(channelData) ||
        (0, pricing_1.isRented)(videoItem) ||
        (0, pricing_1.isBought)(videoItem)) {
        return true;
    }
}
function canAccessFullVersionOfVideo(channelData, videoItem) {
    return (0, pricing_1.isFree)(videoItem) || canAccessPaidVideo(channelData, videoItem);
}
exports.canAccessFullVersionOfVideo = canAccessFullVersionOfVideo;
function getBuyButtonDisplayType(channelData, videoItem) {
    if (canAccessPaidVideo(channelData, videoItem)) {
        return BUY_BUTTON_DISPLAY_TYPES.NONE;
    }
    return getBuyButtonDisplayTypeForPaidVideo(videoItem);
}
exports.getBuyButtonDisplayType = getBuyButtonDisplayType;
function getBuyButtonDisplayTypeForPaidVideo(videoItem) {
    var _isRentEnabled = (0, pricing_1.isRentEnabled)(videoItem);
    var _isSaleEnabled = (0, pricing_1.isSaleEnabled)(videoItem);
    if (_isRentEnabled && _isSaleEnabled) {
        return BUY_BUTTON_DISPLAY_TYPES.BUY_FROM;
    }
    else if (_isSaleEnabled) {
        return BUY_BUTTON_DISPLAY_TYPES.BUY;
    }
    else if (_isRentEnabled) {
        return BUY_BUTTON_DISPLAY_TYPES.RENT;
    }
    return BUY_BUTTON_DISPLAY_TYPES.NONE;
}
exports.getBuyButtonDisplayTypeForPaidVideo = getBuyButtonDisplayTypeForPaidVideo;
// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
function shouldShowSubscribeButton(_a) {
    var settings = _a.settings, videoItem = _a.videoItem, channelData = _a.channelData, showChannelCover = _a.showChannelCover;
    var hasChannelSubscription = isSubscribedToChannel(channelData);
    return (hasSubscriptionPriceInfo(channelData) &&
        !hasChannelSubscription &&
        ((!hasChannelSubscription &&
            shouldShowChannelCover(settings, showChannelCover)) ||
            (channelData.subscriptionOnly &&
                !(0, pricing_1.isFree)(videoItem) &&
                !(0, pricing_1.isRented)(videoItem) &&
                !(0, pricing_1.isBought)(videoItem))));
}
exports.shouldShowSubscribeButton = shouldShowSubscribeButton;
function mainItemIsChannelCover(settings) {
    return settings.numbers.mainItemType === main_item_type_values_1.MAIN_ITEM_TYPE_VALUES.CHANNEL_COVER;
}
exports.mainItemIsChannelCover = mainItemIsChannelCover;
function shouldShowChannelCover(settings, showChannelCover) {
    return showChannelCover && mainItemIsChannelCover(settings);
}
exports.shouldShowChannelCover = shouldShowChannelCover;
// Todo: remove. Use widget/ui-selectors/video-access and overlay-texts
function getPlayButtonType(channelData, videoItem) {
    if (canAccessFullVersionOfVideo(channelData, videoItem)) {
        return PLAY_BUTTON_TYPES.PLAY;
    }
    return PLAY_BUTTON_TYPES.TRAILER_OR_PREVIEW;
}
exports.getPlayButtonType = getPlayButtonType;
function hasSubscriptionPriceInfo(channelData) {
    return channelData
        ? Boolean(dealInfoHelpers.getSubscriptionPriceInfo(channelData.dealInfo || []))
        : false;
}
exports.hasSubscriptionPriceInfo = hasSubscriptionPriceInfo;
function isSubscribedToChannel(channelData) {
    return (0, lodash_1.has)(channelData, 'dgsInfo.subscription');
}
exports.isSubscribedToChannel = isSubscribedToChannel;
//# sourceMappingURL=overlay-buttons-utils.js.map